import React from "react";
import { Link } from "@bloomberg/media-ui-article";

import { TranslatedMessage } from "~utils/i18n/translate";

import styles from "./styles.module.css";

export default function ContactUs() {
    const contactUrl =
        "https://www.bloomberg.com/help/question/submit-feedback-news-coverage/";
    return (
        <div className={styles.contactUsContainer}>
            <Link href={contactUrl} target="_blank">
                <span className={styles.contactUsCopy}>
                    <TranslatedMessage
                        id="contactUs"
                        defaultMessage="Contact us:"
                    />
                </span>
                <div className={styles.contactUsLink}>
                    <TranslatedMessage
                        id="newsFeedback"
                        defaultMessage="Provide news feedback or report an error"
                    />
                </div>
            </Link>
        </div>
    );
}
